import Modals from './modal'

/**
 * Инициализация модальных окон.
 */
export const initModals = () => {
  const modals = Modals.getInstance()

  document.querySelectorAll('[data-modal-name]').forEach((el) => {
    const element = el as HTMLElement
    const modalName = element.dataset.modalName

    if (!modalName) {
      return
    }

    modals.addModal(modalName, {
      autoShow: element.hasAttribute('data-auto-show'),
      autoShowDelay: parseInt(element.dataset.autoShowDelay || '0', 10) || 0,
      openOver: element.hasAttribute('data-open-over'),
      disableUserClose: element.hasAttribute('data-disable-user-close'),
      eventTimeout: 300
    })
  })
}
